import type { ExternalRef } from "@gjwtrack/domain";
import { GitMerge } from "lucide-react";
import { useEffect, useState } from "react";
import { client } from "../lib/client.ts";
import { absTime, relTimeAgo } from "../lib/format.ts";

/** Linked GitLab merge requests (external_refs), refreshed when the issue changes. */
export function MergeRequests({ issueId, updatedAt }: { issueId: number; updatedAt: number }) {
  const [refs, setRefs] = useState<ExternalRef[]>([]);
  useEffect(() => {
    let cancelled = false;
    client.http.refs(issueId).then((r) => !cancelled && setRefs(r)).catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [issueId, updatedAt]);
  if (refs.length === 0) return null;
  const stateClass = (s: string): string => (s === "merged" ? "chip chip-5" : s === "closed" ? "chip chip-3" : s === "opened" ? "chip chip-2" : "chip");
  return (
    <section className="mb-8 ml-10">
      <div className="mb-1 flex items-center gap-2 text-[13px] text-muted">
        <GitMerge size={14} /> Merge requests <span className="tabular-nums">{refs.length}</span>
      </div>
      <ul className="flex flex-col gap-1">
        {refs.map((r) => (
          <li key={r.id} className="flex items-center gap-2">
            <a href={r.url} target="_blank" rel="noopener" className="font-mono text-[13px] text-value hover:underline">!{r.iid}</a>
            <a href={r.url} target="_blank" rel="noopener" className="truncate hover:underline">{r.title}</a>
            <span className={stateClass(r.state)}>{r.state}</span>
            {r.pipeline && <span className={`chip ${r.pipeline === "success" ? "chip-2" : r.pipeline === "failed" ? "chip-3" : ""}`}>pipeline {r.pipeline}</span>}
            {r.labels.map((l) => (
              <span key={l} className="chip">{l}</span>
            ))}
            <span className="ml-auto text-xs text-muted whitespace-nowrap" title={absTime(r.updatedAt)}>{relTimeAgo(r.updatedAt)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
